import { memo, useEffect } from 'react'

import { DIALOG_IDS, modalStore } from '@core/modal'
import { writeHqStoragePaywallSeen } from '@core/session-dialogs'
import { useValues } from '@core/store'

import { endHqStoragePaywallFlow } from '../helpers/hqStoragePaywallFlow'

export const HqStoragePaywallFlowRunner = memo(() => {
    const [activeDialog] = useValues([modalStore.props.getActiveDialog])
    const isFlowOnScreen =
        activeDialog === DIALOG_IDS.hqStoragePaywall || activeDialog === DIALOG_IDS.paywall

    useEffect(() => {
        if (isFlowOnScreen) {
            return
        }

        if (!endHqStoragePaywallFlow()) {
            return
        }

        writeHqStoragePaywallSeen()
    }, [isFlowOnScreen])

    return null
})
